import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { Box } from "../../box/src";
import { Card } from "../../card/src";
import { CardIcon } from './CardIcon';
import { CardLink } from './CardLink';
import { CardText } from './CardText';
export const HorizontalCard = ({ cardProps, description, faIconProps, linkText, linkUrl, title, }) => (_jsx(Card, Object.assign({}, cardProps, { "data-testid": "horizontal-card", height: "100%", px: 6, py: 8, width: "100%", children: _jsx(Box, { alignItems: "center", children: _jsxs(Box, { children: [faIconProps && _jsx(CardIcon, { faIconProps: faIconProps }), _jsxs(TextWrapper, { children: [_jsx(CardText, { description: description, title: title }), linkText && _jsx(CardLink, { link: linkUrl, text: linkText })] })] }) }) })));
const TextWrapper = styled(Box).attrs(() => ({
    flexDirection: 'column',
    ml: 6,
})) ``;
//# sourceMappingURL=HorizontalCard.js.map